export function radioTileTheme(theme, { getTextStyle }) {
  return {
    getCSS: ({ targetElement, columns, isValid }) => {
      switch (targetElement) {
        case 'radio': {
          return {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          };
        }

        case 'radioInput': {
          const errorOutline = `${theme.borderWidths[0]} solid ${theme.colors.conditional.negative.graphics}`;
          const selectedOutline = `${theme.borderWidths[1]} solid ${theme.colors.midBlue.t1000}`;

          return {
            ...theme.focusStyles.focusVisibleAdjacentLabel,
            ':hover + label': {
              cursor: 'pointer',
            },

            ':checked + label': {
              outline: isValid === false ? errorOutline : selectedOutline,
            },

            ...(isValid === false && {
              ':not(:checked) + label': {
                outline: errorOutline,
              },
            }),
          };
        }

        case 'radioLabel': {
          return {
            display: 'flex',
            alignItems: 'center',
            justifyContent: columns === 2 ? 'center' : 'flex-start',
            padding: theme.space[6],
            minHeight: '20px',
            height: '100%',
            ...getTextStyle({ name: 'body1', mode: 'container' }),
            color: theme.colors.black,
            backgroundColor: theme.colors.white,
            outline: `${theme.borderWidths[0]} solid ${theme.colors.grey.t30}`,
            borderRadius: theme.radii[2],
          };
        }

        case 'description': {
          return {
            marginTop: theme.space[2],
          };
        }

        default: {
          return null;
        }
      }
    },
  };
}
